import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import { format } from 'date-fns'
import { Milestone } from '../../../api/v2/models/user_goal'

@Component({})
export default class GoalMilestone extends Vue {
  @Prop({ required: true })
  milestone: Milestone

  @Prop({ default: false })
  isFirst: boolean

  @Prop({ default: false })
  isLast: boolean

  @Emit()
  toExam(examId: string) {
    // Noop
  }

  @Emit()
  toCourse(courseId: string) {
    // Noop
  }

  mobile = checkMobile()

  get progressPercent() {
    const length = this.milestone.enrollments.length

    if (length == 0) {
      return 100
    }

    let total = 0
    this.milestone.enrollments.forEach((item) => (total += item.progressPercent))

    return Math.round(total / length)
  }

  dateFormat(date: string, formatDate: string = 'MM/DD') {
    return format(date, formatDate)
  }

  mounted(){
    if (!this.milestone.completedAt) {
      (this.$refs['mileston-toggle'] as HTMLElement).click()
    }
  }
}
